/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { sitesUrls } from "§/src/utils/sitesUrls"
import { getFormattedLanguage } from "§/src/utils/functions"

function SEO({ seo, translations, langReplace, title, desc }) {
  const { site } = useStaticQuery(
    graphql`
      query SeoQuery {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  )

  const metaTitle = seo?.title || title
  const metaDescription = seo.metaDesc || desc || site.siteMetadata.description
  const ogUrl = site.siteMetadata.siteUrl + seo?.opengraphUrl
  const sitesList = sitesUrls("all", translations, langReplace)
  // const canonical = canonicalUrl === 'homePage' ? site.siteMetadata.siteUrl : site.siteMetadata.siteUrl + seo?.canonical

  return (
    <React.Fragment>
      <title>{metaTitle}</title>

      {/* alternate for each languages */}
      {sitesList &&
        Object.keys(sitesList)
          .map(key => (
            <link
              key={key}
              rel="alternate"
              href={sitesList[key].tUrl || sitesList[key].url}
              hrefLang={getFormattedLanguage(key)}
            />
          ))}

      {/* x-default on main site - removed */}
      {/* {sitesList &&
        Object.keys(sitesList)
          .filter(key => key === 'en_US')
          .map(key => (
            <link
              key={key}
              rel="alternate"
              hrefLang="x-default"
              href={sitesList[key].tUrl || sitesList[key].url}
            />
          ))} */}

      {/* canonical on self */}
      {sitesList &&
        Object.keys(sitesList)
          .filter(key => key === process.env.GATSBY_SITE_LANG)
          .map(key => (
            <link
              key={key}
              rel="canonical"
              href={sitesList[key].tUrl || sitesList[key].url}
            />
          ))}

      {seo?.metaRobotsNoindex === 'noindex' && (
        <meta name="robots" content="noindex, nofollow" />
      )}

      <meta name="title" content={seo?.opengraphTitle} />
      <meta name="description" content={metaDescription} />
      <meta
        property="og:locale"
        content={getFormattedLanguage(process.env.GATSBY_SITE_LANG) || "en"}
      />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:site_name" content="Gefran s.p.a." />
      <meta property="og:image" content={seo?.opengraphImage?.sourceUrl} />
      <meta property="og:title" content={seo?.opengraphTitle || metaTitle} />
      <meta
        property="og:description"
        content={seo?.opengraphDescription || metaDescription}
      />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo?.twitterTitle || metaTitle} />
      <meta
        name="twitter:description"
        content={seo?.twitterDescription || metaDescription}
      />
    </React.Fragment>
  )
}

SEO.defaultProps = {
  lang: getFormattedLanguage(process.env.GATSBY_SITE_LANG) || "en",
  meta: [],
  description: "",
  metaTitle: "Gefran s.p.a.",
  uri: "",
  seo: {},
}

SEO.propTypes = {
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  description: PropTypes.string,
  metaTitle: PropTypes.string.isRequired,
  uri: PropTypes.string.isRequired,
  seo: PropTypes.object.isRequired,
}

export default SEO
